// components/LocationAutocomplete.js
import React, { useRef } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const libraries = ["places"];

const LocationAutocomplete = ({ onPlaceSelected }) => {
  const inputRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyAAHKz5tes9kExmji4EOCRtq5IqSQmKR9w", // Ganti dengan milikmu
    libraries,
  });

  const handleLoad = () => {
    if (!window.google || !inputRef.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ["(cities)"], // Bisa juga "(cities)"
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place && place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const components = place.address_components || [];

        const getComponent = (type) => {
          const found = components.find(comp => comp.types.includes(type));
          return found ? found.long_name : "";
        };

        const locationData = {
          name: place.name,
          address: place.formatted_address,
          latitude: lat,
          longitude: lng,
          negara: getComponent("country"),
          province: getComponent("administrative_area_level_1"),
          city: getComponent("administrative_area_level_2"),
          kecamatan: getComponent("administrative_area_level_3"),
        };

        onPlaceSelected(locationData);
      }
    });
  };

  return (
    <>
      {isLoaded && (
        <input
          type="text"
          ref={inputRef}
          onFocus={handleLoad}
          placeholder="Ketik nama kota / negara"
          style={{ width: "100%", padding: "10px", fontSize: "16px" }}
        />
      )}
    </>
  );
};

export default LocationAutocomplete;
